import FinishGoodQcConfirmation from '@/models/FinishGoodQcConfirmation/FinishGoodQcConfirmation';

export default class FinishGoodQcConfirmationFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.requestNumber = '';
		this.id = '';
		this.processById  = '';
		this.processByFirstName = '';
		this.qcDateFrom = '';
		this.qcDateTo = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			requestNumber : '0',
			id : '0',
			processById : '0',
			processByFirstName : '0',
			qcDateFrom : '0',
			qcDateTo : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}